<template>
    <VJoyDialogTrigger :dialog="dialogRef">
        <VJoyButton
            id="share-profile-button"
            data-testid="freelancer-share-profile-cta-open-dialog"
            icon="social-share"
            variant="ghost"
            :full="true"
            size="small"
            :disabled="isCtaDisabled"
            @click="onShareClick"
        >
            {{ t('profile.features.share-profile.title') }}
        </VJoyButton>
    </VJoyDialogTrigger>
    <VJoyDialog ref="dialogRef" data-testid="freelancer-share-profile-dialog" @dialog:hide="handleSeoDialogHide">
        <template #dialog-header>{{ t('profile.features.share-profile.title') }}</template>
        <template #dialog-body>
            <VJoyWrapper v-bind="{direction: 'column', align: 'stretch', rowGap: '6'}" class="freelancer-share-profile__wrapper">
                <div>
                    <h2>{{ t('profile.features.share-profile.link.title') }}</h2>
                    <VJoyWrapper :align="'flex-end'" class="freelancer-share-profile__seo-alias" no-margin>
                        <VJoyInput data-testid="freelancer-seo-alias-input" name="freelancer-seo-alias" :model-value="profileLink" readonly />
                        <VJoyButton data-testid="freelancer-seo-alias-input-cta-copy" @click="handleClickOnCopy">
                            {{ t('generic.action.copy') }}
                        </VJoyButton>
                    </VJoyWrapper>
                </div>
                <div>
                    <h2>{{ t('profile.features.share-profile.social-networks.title') }}</h2>
                    <VJoyWrapper no-margin>
                        <OldShareProfileSocialNetwork
                            :profile-link="profileLink"
                            :profile-firstname="profile?.firstname || ''"
                            :profile-lastname="profile?.lastname || ''"
                            :profile-headline="profile?.headline || ''"
                            :profile-account-id="profile?.accountId || ''"
                            social-network="linkedin"
                        />
                        <OldShareProfileSocialNetwork
                            :profile-link="profileLink"
                            :profile-firstname="profile?.firstname || ''"
                            :profile-lastname="profile?.lastname || ''"
                            :profile-headline="profile?.headline || ''"
                            :profile-account-id="profile?.accountId || ''"
                            social-network="facebook"
                        />
                    </VJoyWrapper>
                </div>
            </VJoyWrapper>
        </template>
    </VJoyDialog>
</template>
<script setup lang="ts">
    import {computed, useTemplateRef} from 'vue';
    import {storeToRefs} from 'pinia';
    import {useHydrationState, useProfileTracking, useTranslation} from '#imports';
    import {VJoyButton, VJoyDialog, VJoyDialogTrigger, VJoyInput, VJoyWrapper} from '@maltjoy/core-vue';
    import {useShareProfile} from '~/features/share-profile/composable/useShareProfile';
    import OldShareProfileSocialNetwork from '~/features/share-profile/ui/OldShareProfileSocialNetwork.vue';
    import {useProfileStore} from '~/store/profileStore';

    // Composables
    const {t} = useTranslation();
    const {isHydrated} = useHydrationState();
    const {profile} = storeToRefs(useProfileStore());
    const {trackProfileSocialShareOpened} = useProfileTracking();

    const {profileLink, handleClickOnCopy, handleSeoDialogHide} = useShareProfile();

    const isCtaDisabled = computed(() => !isHydrated.value);

    // Refs
    const dialogRef = useTemplateRef('dialogRef');

    function onShareClick() {
        trackProfileSocialShareOpened(profile.value?.accountId || '', false);
    }
</script>
<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text' as text;

    .freelancer-share-profile {
        &__wrapper {
            margin-top: var(--joy-core-spacing-5);

            h2 {
                @include text.getFontBySize(primary-450);

                margin-bottom: var(--joy-core-spacing-2);
            }
        }

        &__seo-alias {
            .joy-input--medium {
                flex-grow: 1;
            }
        }
    }
</style>
